/**
 * DraftPlanIcon — clipboard with three lines of writing.
 * Phase: draft-plan.
 */

import type { ReactNode } from 'react';

interface IconProps {
  readonly size?: number;
  readonly color?: string;
}

export function DraftPlanIcon({ size = 18, color = '#F4EFE2' }: IconProps): ReactNode {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M6.4 3.5h11.1v17H6.5z" />
      <path d="M9.5 3.5v-1h5v1" />
      <path d="M9 9.5h6.5" />
      <path d="M9 12.5h6" />
      <path d="M9 15.5h4.5" />
    </svg>
  );
}
